import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const editVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type EditProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof editVariants> &
  IconProps;

export const Edit = React.forwardRef<SVGSVGElement, EditProps>(
  (
    {
      className,
      variant,
      viewBox = '10 3 20 34',
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        className={cn(
          editVariants({
            variant,
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <path
          width={width}
          height={height}
          d="M23.2424 12.5396C23.8016 11.9803 24.56 11.6661 25.3508 11.666C26.1417 11.6659 26.9002 11.98 27.4595 12.5392C28.0187 13.0984 28.333 13.8568 28.3331 14.6476C28.3331 15.4385 28.0191 16.197 27.4599 16.7563L26.7166 17.4996L22.4999 13.2829L23.2424 12.5396ZM21.6166 14.1663L13.2832 22.4988C12.9446 22.8375 12.7066 23.2636 12.5957 23.7296L11.6832 27.5638C11.6585 27.6677 11.6608 27.7761 11.69 27.8789C11.7191 27.9816 11.774 28.0751 11.8496 28.1506C11.9251 28.226 12.0187 28.2809 12.1215 28.3099C12.2242 28.3389 12.3327 28.3411 12.4366 28.3163L16.2707 27.4038C16.7368 27.2927 17.1629 27.0544 17.5016 26.7154L25.8332 18.3846L21.6157 14.1663H21.6166Z"
        />
      </svg>
    );
  },
);

Edit.displayName = 'Edit';
